import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { BaryComponentHelper } from 'app/shared/util/bary-component-helper';
import { IBaryInput } from 'models/bary-input';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';

import { TranslateDirective } from '../../../../directives/translate.directive';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';
import { BaryIconComponent } from '../bary-icon/bary-icon.component';

@Component({
  selector: 'jhi-bary-input-checkbox',
  templateUrl: './bary-input-checkbox.component.html',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, MDBBootstrapModulesPro, TranslateDirective, BaryIconComponent],
  styleUrls: ['./bary-input-checkbox.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BaryInputCheckboxComponent implements IBaryInput, OnInit {
  @Input() id: string = '';
  @Input() label?: string;
  @Input() disabled = false;
  @Input() inline = false;
  @Input() control: any = new FormControl('');
  @Input() tooltip?: string;

  @Output() onChangeEvent = new EventEmitter();

  public isRequired = false;

  protected readonly FAS = FaDirectiveEnum.FAS;

  public ngOnInit(): void {
    this.id = !this.id ? BaryComponentHelper.makeId() : this.id;
    this.isRequired = this.control.errors?.required || this.control.errors?.requireTrueOrError;
    if (this.disabled) {
      this.control.disable();
    }
  }
}
